import { apiClient } from '../../api/client';
import type { components } from '../../api/generated/schema';
import type { CollectionChanges, NewCollection } from '../../domain/collections';
import { mapped } from '../errors';
import type { CollectionRole, CollectionsRepository } from './CollectionsRepository';
import { toCollection, toCollectionChanges, toNewCollection } from './mapping';

type S = components['schemas'];

const path = (id: string) => `/api/v1/collections/${encodeURIComponent(id)}/`;

export const httpCollectionsRepository: CollectionsRepository = {
  list: (role?: CollectionRole) =>
    mapped(async () => {
      const query = role ? `?role=${role}` : '';
      const list = await apiClient.get<S['Collection'][]>(`/api/v1/collections/${query}`);
      return list.map(toCollection);
    }),
  get: (id: string) => mapped(async () => toCollection(await apiClient.collectionGet(id))),
  create: (input: NewCollection) =>
    mapped(async () => toCollection(await apiClient.collectionCreate(toNewCollection(input)))),
  update: (id: string, changes: CollectionChanges) =>
    mapped(async () =>
      toCollection(await apiClient.collectionUpdate(id, toCollectionChanges(changes))),
    ),
  delete: (id: string, confirmListingCount: number) =>
    mapped(async () => {
      await apiClient.send('DELETE', `${path(id)}?confirm_listing_count=${confirmListingCount}`);
    }),
};
